const STRATEGY_TRANSLATION_KEYS = new Map([
    [1, 'sections.campaigns.new-campaign.wizard-basics.timing.evenly'],
    [2, 'sections.campaigns.new-campaign.wizard-basics.timing.ASAP'],
    [3, 'sections.campaigns.new-campaign.wizard-basics.timing.exclusivity'],
    [4, 'sections.campaigns.new-campaign.wizard-basics.timing.optimizer'],
    [
        5,
        'sections.campaigns.new-campaign.wizard-basics.timing.viooh_distribution',
    ],
]);

export const getStrategyTranslationKey = ({ strategy } = {}) =>
    STRATEGY_TRANSLATION_KEYS.get(strategy) ?? null;
